import React from "react";
import { Player } from "video-react";
import Styles from "./VideoPlayer.css";
import { isMobile } from "react-device-detect";

export default props => {
  return (
    <div className={isMobile ? "VideoMobile" : "VideoWeb"}>
      <Player src="http://getupstudio.co/img/PranaVideo2.mp4" autoPlay />
    </div>
  );
};
